import component from "./FormikCheckbox";

export default component;
